'use client';

import * as React from 'react';

import assetLoader from '@/utils/asset-loader';

import styles from './logo-section.module.scss';

export function LogoSection() {
    return (
        <header className={styles.headerContainer}>
            <div
                className={styles.logoGroup}
                style={{
                    backgroundImage: `url(${assetLoader({
                        src: '/indeed/logo/logo_group.svg',
                    })})`,
                }}
            />
        </header>
    );
}
